export const notifications = {
  new: "Neu",
  alerts: "Warnungen",
  events: "Events",
  logs: "Logs",
  notifications: "Benachrichtigungen"
};
